import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchMany, updateOne } from "actions/resources";
import { type UserAttributes } from "resourceModels/User";
import { getResource, getResources } from "selectors/resources";

export function useUsers() {
  const currentUser = useSelector((state) => getResource(state, "user"));
  const allUsers = useSelector((state) => getResources(state, "user"));
  const dispatch = useDispatch();

  useEffect(() => {
    if (!allUsers) {
      dispatch(fetchMany("user"));
    }
  }, [allUsers, dispatch]);

  const updateCurrentUser = useCallback(
    (data: Partial<UserAttributes>) => {
      if (!currentUser?.id) {
        return;
      }

      dispatch(updateOne("user", currentUser.id, data));
    },
    [dispatch, currentUser?.id],
  );

  return {
    currentUser,
    allUsers: allUsers && allUsers.toArray(),
    updateCurrentUser,
    isReadOnly: currentUser?.role === "read_only",
    currentUserIsAdaEmployee: !!currentUser?.email?.endsWith("@ada.support"),
  };
}
